module.exports = __webpack_public_path__ + "img/jordskokkesuppe_prep.a8c3d8b3.jpg";